module.exports = __webpack_public_path__ + "media/images/icons/filled/compass-0f634821ff49610a8035b3c42e0ca7ac.svg";